import { InputAdornment, SxProps, TextField } from "@mui/material";
import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../../../assets/icons/Icons";
import { SearchBox } from "../../../components/common/SearchWithAutocomplete/SearchWithAutocomplete.styles";

interface Props {
    sx?: SxProps;
    onSearchHandler: (searchQuery: string) => void;
}

export default function ServerSideSearchBar(props: Props) {
    const { t } = useTranslation();
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const debouncedResults = useCallback((s: string) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => props.onSearchHandler(s), 500);
    }, [props.onSearchHandler]);

    useEffect(() => {
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    });

    return (
        <SearchBox sx={props.sx}>
            <TextField
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => debouncedResults(event.target.value)}
                placeholder={t("search") + "..."}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    },
                }}
                aria-label={t("search")}
            />
        </SearchBox>
    );
};
